<template>
  <div>
    <v-progress-circular
      v-if="loading"
      indeterminate
      size="50"
    ></v-progress-circular>
    <template v-else>
      <PageHeading
        title="Nova Nota"
      />
      <v-container fluid>
        <v-form v-model="valid" ref="form">
          <item-select
            v-model="item_paths"
            dense
          ></item-select>
          <v-textarea 
            placeholder="Escreva aqui..."
            v-model="description"
            :rules="descriptionRules"
            outlined
            no-resize
          ></v-textarea>
          <!--
          <div class="text-h6 text-left">Arquivo</div>
          <v-file-input
            placeholder="Clique para adicionar.. (max 2MB)"
            v-model="file"
            :rules="fileRules"
            outlined
            dense
            prepend-icon=""
          ></v-file-input>
          -->
        </v-form>
        <!-- Floating Action Buttons. AKA: cancel and accept buttons -->
        <v-btn
          class="mx-2"
          fab
          fixed
          bottom
          left
          dark
          color="#802C12"
          @click="close()"
        >
          <v-icon dark>mdi-close</v-icon>
        </v-btn>
        <v-fab-transition>
          <v-btn
            class="mx-2"
            fab
            fixed
            bottom
            right
            dark
            color="#802C12"
            @click="send()"
          >
            <v-icon dark>mdi-check</v-icon>
          </v-btn>
        </v-fab-transition>
      </v-container>
    </template>
  </div>
</template>
<script>
import firebase from "firebase/app";
import { storage } from "@/firebase";
import { mapGetters } from "vuex";
import PageHeading from "@/components/PageHeading.vue";
import ItemSelect from "@/components/ItemSelect.vue";
import { splitPath } from '@/store/helpers';

export default {
  name: "CreateNote",
  components: {
    PageHeading,
    "item-select": ItemSelect,
  },
  data: () => ({
    loading: true,
    valid: false,
    item_paths: [],
    file: null,
    context: null,
    description: "",
    descriptionRules: [
      v => !!v || "Descrição não pode ficar vazia."
    ],
    itemRules: [
      v => !!v || "Um item deve ser associado."
    ],
    fileRules: [
      v => !v || v.size < 2000000 || "Arquivo muito grande. Máximo 2MB"
    ]
  }),
  mounted() {
    this.setup();
  },
  computed: {
    items() {
      const obj = [];
      if (this.context) {
        this.context.categories.forEach(cat => {
          cat.items.forEach(item => {
            obj.push({
              text: `${cat.name}/${item.name}`,
              value: `/${this.context_id}/${cat.id}/${item.id}`
            });
          });
        });
      }
      return obj;
    },
    group_id() { return this.$route.params.group_id; },
    context_id() { return this.$route.params.context_id; },
    ...mapGetters([
      "loggedIn",
      "user",
      "user_id"
    ])
  },
  methods: {
    setup() {
      if (this.loggedIn) {
        this.$store.dispatch(`user/get`, {
          path: `groups/${this.group_id}/context/${this.context_id}`
        }).then(context => {
          this.context = context;
          this.loading = false;

          if (this.$route.query.path) {
            const [cat_id, item_id] = splitPath(this.$route.query.path).splice(1);

            const cat = this.context.categories.find(cat => cat.id == cat_id);
            const item = cat?.items.find(i => i.id == item_id);

            if (cat && item) {
              this.item_paths = [{
                path: this.$route.query.path,
                text: `${cat.name}/${item.name}`,
              }];
            }
          }
        })
        .catch(error => {
          console.error("An error occurred while trying to get group and context.");
          console.error(error);
        });
      } else {
        console.warn("CreateNote.vue was loaded with no user logged in.");
      }
    },
    uploadFile(name_prefix, file) {
      const ref = storage.ref().child(`${this.user_id}/notes/${name_prefix}-${file.name}`);
      const metadata = {
        contentType: file.type
      };
      return ref
        .put(file, metadata)
        .then(snapshot => snapshot.ref.getDownloadURL());
    },
    close() {
      this.$router.go(-1);
    },
    async send() {
      this.$refs.form.validate();
      if (this.valid) {
        this.loading = true;
        const doc_ref = this.group_ref().collection("notes").doc()
        const note = {
          content: this.description,
          time: firebase.firestore.Timestamp.now(),
          uid: this.user_id,
          item_paths: this.item_paths
        };
        
        if (this.file)
          note.fileURL = await this.uploadFile(+new Date() + "-" + doc_ref.id, this.file);
          
        doc_ref.set(note)
          .then(() => {
            this.loading = false;
            this.close();
          });
      }
    },
    group_ref() { return this.$store.getters[`user/${this.group_id}/ref`] },
    context_ref() { return this.$store.getters[`user/${this.group_id}/${this.context_id}/ref`]; }
  }
}
</script>
<style lang="scss">
.v-list-item {
  text-align: left;
}
</style>